import add from "date-fns/add";
import addDays from "date-fns/addDays";
import endOfDay from "date-fns/endOfDay";
import startOfDay from "date-fns/startOfDay";
import startOfWeek from "date-fns/startOfISOWeek";
import endOfWeek from "date-fns/endOfISOWeek";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import format from "date-fns/format";
import get from "lodash/get";
import pick from "lodash/pick";

const formatDate = (date) => {
    return format(date, "dd.MM.yyyy");
}

export const getValueDefault = (value, ) => { return value };



export const contains = [
    { name: "contains", getValue: getValueDefault },
]


export const includes = [
    { name: "includes", getValue: getValueDefault },
]


export const allOf = [
    { name: "allOf", getValue: getValueDefault },
]


export const range = [
    {
        order: 100,
        name: "before",
        getValue (value, ) {
            return {
                max: value?.max || "",
                min: ""
            }
        }
    },
    {
        order: 200,
        name: "after",
        getValue (value, ) {
            return {
                min: value?.min || "",
                max: ""
            }
        }
    },
    {
        order: 300,
        name: "between",
        getValue (value, ) {
            return pick(value, "min", "max") 
        }
    },
]


export const date = [
    {
        name: "today",
        getValue() {
            const date = new Date();
            return {
                min: formatDate(startOfDay(date)),
                max: formatDate(endOfDay(date)),
            }
        }
    },
    {
        name: "yesterday",
        getValue() {
            const date = new Date();
            return {
                min: formatDate(addDays(startOfDay(date), -1)),
                max: formatDate(addDays(endOfDay(date), -1)),
            }
        }
    },
    {
        name: "tomorrow",
        getValue() {
            const date = new Date();
            return {
                min: formatDate(addDays(startOfDay(date), 1)),
                max: formatDate(addDays(endOfDay(date), 1)),
            }
        }
    },
    {
        name: "thisweek",
        getValue() {
            const date = new Date();
            return {
                min: formatDate(startOfWeek(date)),
                max: formatDate(endOfWeek(date)),
            }
        }
    },
    {
        name: "lastweek",
        getValue() {
            const date = add(new Date(), { weeks: -1 });
            return {
                min: formatDate(startOfWeek(date)),
                max: formatDate(endOfWeek(date)),
            }
        }
    },
    {
        name: "nextweek",
        getValue() {
            const date = add(new Date(), { weeks: 1 });
            return {
                min: formatDate(startOfWeek(date)),
                max: formatDate(endOfWeek(date)),
            }
        }
    },
    {
        name: "thismonth",
        getValue() {
            const date = new Date();
            return {
                min: formatDate(startOfMonth(date)),
                max: formatDate(endOfMonth(date)),
            }
        }
    },
    {
        name: "lastmonth",
        getValue() {
            const date = add(new Date(), { months: -1 });
            return {
                min: formatDate(startOfMonth(date)),
                max: formatDate(endOfMonth(date)),
            }
        }
    },
    {
        name: "nextmonth",
        getValue() {
            const date = add(new Date(), { months: 1 });
            return {
                min: formatDate(startOfMonth(date)),
                max: formatDate(endOfMonth(date))
            }
        }
    },
    {
        order: 101,
        name: "before_today",
        getValue() {
            const date = add(new Date(), { days: -1 });
            return {
                max: formatDate(startOfDay(date)),
                min: "",
            }
        }
    },
    {
        order: 102,
        name: "on_or_before_today",
        getValue() {
            return {
                max: formatDate(endOfDay(new Date())),
                min: "",
            }
        }
    },
    {
        order: 201,
        name: "after_today",
        getValue() {
            const date = add(new Date(), { days: 1 });
            return {
                min: formatDate(startOfDay(date)),
                max: "",
            }
        }
    },
    {
        order: 202,
        name: "on_or_after_today",
        getValue() {
            return {
                min: formatDate(startOfDay(new Date())),
                max: "",
            }
        }
    },
    ...range,
].sort((a, b) => ((a.order ?? 0) - (b.order ?? 0)));


export const filterTypes = {
    text: contains,
    textarea: contains,
    wysiwyg: contains,
    bool: includes,
    yesno: includes,
    belongs_to: includes,
    belongs_to_many: allOf,
    date: date,
    datetime: date,
    time: range,
    file: [],
    image: [],
}

export const isDateFilter = (filterType) => {
    return !!date.some(filter => filter.name === filterType && !range.includes(filter))
}

export const getFilterType = (type) => get(filterTypes, type)